<template>
  <el-submenu v-if="menuNode.children.length" :index="`${menuNode.id}`">
    <template #title>
      <div :id="`mItem_${menuNode.id}`" class="menu_item_title">
        {{ menuNode.name }}
      </div>
    </template>
    <template v-for="child in menuNode.children">
      <RecursMenuItem :key="child.id" :menuNode="child" />
    </template>
  </el-submenu>
  <el-menu-item v-else :index="`${menuNode.id}`">
    <div :id="`mItem_${menuNode.id}`" class="menu_item_title">
      {{ menuNode.name }}
    </div>
  </el-menu-item>
</template>
<script>
export default {
  name: "RecursMenuItem",
  props: {
    menuNode: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/RecursiveMenu/RecursiveMenuItem.vue